import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { hastingsConfig } from "./data";

export default function HastingsPage() {
  return <CityPageTemplate config={hastingsConfig} />;
}